import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useDashboardStore = defineStore('dashboard', () => {
  const apiTotal = ref(1700000)
  // A4/6.1：顶部总数使用可空“成功值”：首次失败显示 —/暂不可用；真实成功结果 0 才显示 0。
  const fetchedOpinionTotal = ref<number | null>(null)
  const fetchedOpinionTotalState = ref<'loading' | 'ready' | 'failed'>('loading')
  const fetchedOpinionTotalAt = ref<number | null>(null)
  const formattedFetchedOpinionTotal = computed(() =>
    fetchedOpinionTotal.value === null ? '—' : fetchedOpinionTotal.value.toLocaleString())
  const formattedApiTotal = computed(() => apiTotal.value.toLocaleString())
  const opinionApiRatio = computed(() => {
    if (fetchedOpinionTotal.value === null) return '--'
    if (!apiTotal.value) return '0.00%'
    return `${((fetchedOpinionTotal.value / apiTotal.value) * 100).toFixed(2)}%`
  })

  const selectedCardsRef = ref<{ [key: string]: boolean }>({
    舆情关键词: true,
    舆情等级分布与走势: true,
    黑公关监测: true,
    舆情性质分类: true,
    活跃作者统计: true,
    舆情热搜: true,
    全国舆情热点图: true,
    舆情分布概览: true,
  })

  const cardOptions = computed(() => Object.keys(selectedCardsRef.value))

  function setCardVisibility(cardName: string, isVisible: boolean) {
    if (cardName in selectedCardsRef.value) {
      selectedCardsRef.value[cardName] = isVisible
    }
  }

  function toggleCardVisibility(cardName: string) {
    if (cardName in selectedCardsRef.value) {
      selectedCardsRef.value[cardName] = !selectedCardsRef.value[cardName]
    }
  }

  return {
    apiTotal,
    fetchedOpinionTotal,
    fetchedOpinionTotalState,
    fetchedOpinionTotalAt,
    formattedFetchedOpinionTotal,
    formattedApiTotal,
    opinionApiRatio,
    selectedCardsRef,
    cardOptions,
    setCardVisibility,
    toggleCardVisibility,
  }
})
